import { cn } from "@/lib/utils"

interface WordmarkProps {
  className?: string
  /** Retained for API compatibility; the wordmark is now image-based. */
  weight?: number
}

// App brand wordmark. Image-based so it carries the custom geometric letterforms
// (dotless "i", spaced "t") that a font can't reproduce. Height tracks the font
// size of the call site (e.g. text-xl / text-2xl) via the 1em-relative height.
export function Wordmark({ className }: WordmarkProps) {
  return (
    <img
      src="/bidcontext-wordmark.png"
      alt="Bidcontext"
      draggable={false}
      className={cn("inline-block w-auto select-none", className)}
      style={{ height: "0.82em" }}
    />
  )
}
